import BackTitle from '@/editor/collapse/views/more-collapse/plugins/back-title/back-title';
import { useLocaleStore } from '@/i18n';
import styles from './index.module.less';

interface IProps {
    onBackClick?: () => void;
}
const AIMattingBackTitle: React.FC<IProps> = ({ onBackClick }) => {
    const { $t } = useLocaleStore();

    return (
        <div className={styles.backTitle}>
            <BackTitle
                handleClick={() => onBackClick?.()}
                title={$t((v) => v.extensions.aiMatting.title)}
                iconName="QuestionMarkCircleBold"
                showDemo={false}
            />
        </div>
    );
};

export default AIMattingBackTitle;
